export const LOCALIZED_QUICK_ACTIONS = [
  'businessProfile.aiAssistant.quickAction1',
  'businessProfile.aiAssistant.quickAction2',
  'businessProfile.aiAssistant.quickAction3',
];

export const stateMap = Object.freeze({
  AK: 'Alaska',
  AL: 'Alabama',
  AR: 'Arkansas',
  AS: 'American Samoa',
  AZ: 'Arizona',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  IA: 'Iowa',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  MA: 'Massachusetts',
  MD: 'Maryland',
  ME: 'Maine',
  MI: 'Michigan',
  MN: 'Minnesota',
  MO: 'Missouri',
  MP: 'Northern Mariana Islands',
  MS: 'Mississippi',
  MT: 'Montana',
  NA: 'National',
  NC: 'North Carolina',
  ND: 'North Dakota',
  NE: 'Nebraska',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NV: 'Nevada',
  NY: 'New York',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VA: 'Virginia',
  VI: 'Virgin Islands',
  VT: 'Vermont',
  WA: 'Washington',
  WI: 'Wisconsin',
  WV: 'West Virginia',
  WY: 'Wyoming',
});

const WFC_SERVICES = {
  BASIC: 'worry_free_service_basic',
  ESSENTIAL: 'worry_free_service',
  ADVANCED: 'worry_free_service_advanced',
  ADVANCED_ADDON: 'worry_free_service_advanced_addon',
};

const hasWfcBasic = (entitlements) => entitlements.has(WFC_SERVICES.BASIC);
const hasWfcEssential = (entitlements) => entitlements.has(WFC_SERVICES.ESSENTIAL);
const hasWfcAdvanced = (entitlements) =>
  entitlements.has(WFC_SERVICES.ADVANCED) || entitlements.has(WFC_SERVICES.ADVANCED_ADDON);

export const WFC_UPSELL_CONFIG = {
  basic: {
    title: 'businessProfile.aiAssistant.sduCompliance.title.basic',
    url: (path) => `${path}/wfc-services`,
    shouldShow: (entitlements) =>
      !hasWfcBasic(entitlements) && !hasWfcEssential(entitlements) && !hasWfcAdvanced(entitlements),
  },
  essential: {
    title: 'businessProfile.aiAssistant.sduCompliance.title.essential',
    url: (path) => `${path}/wfc-services?package=essential`,
    shouldShow: (entitlements) =>
      hasWfcBasic(entitlements) && !hasWfcEssential(entitlements) && !hasWfcAdvanced(entitlements),
  },
  advanced: {
    title: 'businessProfile.aiAssistant.sduCompliance.title.advanced',
    url: (path) => `${path}/wfc-advanced`,
    shouldShow: (entitlements) => hasWfcEssential(entitlements) && !hasWfcAdvanced(entitlements),
  },
};
